<template>
  <StModal size="medium" :on-close="() => emit(CLOSE)">
    <div class="st-account-verification-modal">
      <StIcon name="st-mail-send-big" />
      <StHeadline :level="2"> Skicka nytt verifieringsmejl </StHeadline>
      <p class="st-account-verification-modal__paragraph">
        Är du säker på att du vill skicka ett nytt verifieringmejl till kontot?
      </p>
      <ModalAccountDetails
        :account-name="account.accountName"
        :email="account.email"
        :organization-name="account.companyName"
      />
      <div class="st-account-verification-modal__buttons">
        <StButton rectangular secondary full-width @click="emit(CLOSE)">
          Avbryt
        </StButton>
        <StButton
          rectangular
          full-width
          @click="emit('on-verification')"
          :is-loading="isLoading"
        >
          Skicka mejl
        </StButton>
      </div>
      <StError v-if="errorMessage" :error-message="errorMessage" />
    </div>
  </StModal>
</template>

<script setup>
import { StModal, StButton, StHeadline, StError, StIcon } from "skanetrafiken";
import { CLOSE } from "@/constants";
import ModalAccountDetails from "../common/ModalAccountDetails.vue";

const emit = defineEmits(["close", "on-verification"]);

defineProps({
  isLoading: Boolean,
  account: Object,
  errorMessage: String,
});
</script>

<style lang="scss" scoped>
@import "~skanetrafiken/dist/scss/main.scss";
.st-account-verification-modal {
  text-align: center;
  font-family: var(--font-primary);
  max-width: rem-calc(600);

  & > :not(:last-child) {
    margin-bottom: rem-calc(24);
  }

  &__paragraph {
    line-height: rem-calc(20);
    color: var(--text-color-primary);
  }

  &__buttons {
    display: flex;

    & > :last-child {
      margin-left: rem-calc(16);
    }
  }
}
</style>
